import React, { useState, useEffect } from 'react';
import ConsultationModal from './ConsultationModal';
import SpecialOffer from './SpecialOffer';

const ModalManager = () => {
  const [activeModal, setActiveModal] = useState(null);
  const [timeOnSite, setTimeOnSite] = useState(0);
  const [hasScrolled, setHasScrolled] = useState(false);
  const [showExitIntent, setShowExitIntent] = useState(false);
  const [showSpecialOffer, setShowSpecialOffer] = useState(false);
  const [modalsDisabled, setModalsDisabled] = useState(false);

  useEffect(() => {
    // Don't track time if modals are disabled
    if (modalsDisabled) return;

    // Track time on site
    const timeInterval = setInterval(() => {
      setTimeOnSite(prev => prev + 1);
    }, 1000);

    // Track scroll position
    const handleScroll = () => {
      const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
      if (scrollPercent > 30 && !hasScrolled) {
        setHasScrolled(true);
      }
    };

    // Track mouse movement for exit intent
    const handleMouseMove = (e) => {
      if (e.clientY <= 10 && !showExitIntent && timeOnSite > 30) {
        setShowExitIntent(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    document.addEventListener('mousemove', handleMouseMove);

    return () => {
      clearInterval(timeInterval);
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, [modalsDisabled]);

  useEffect(() => {
    // Don't show modals if they've been disabled
    if (modalsDisabled) return;

    // Show special offer after 7 minutes (420 seconds) - highest value offer
    if (timeOnSite === 420 && !activeModal && !showSpecialOffer) {
      setShowSpecialOffer(true);
      return;
    }

    // Show time-based modal after 5 minutes (300 seconds)
    if (timeOnSite === 300 && !activeModal && !showSpecialOffer) {
      setActiveModal('time');
    }

    // Show scroll-based modal after scrolling 50% and spending 45 seconds
    if (hasScrolled && timeOnSite === 45 && !activeModal && !showSpecialOffer) {
      setActiveModal('scroll');
    }

    // TEMPORARY: Show modal immediately for testing (remove after testing)
    // if (timeOnSite === 5 && !activeModal && !showSpecialOffer) {
    //   setActiveModal('time');
    // }

    // Show exit intent modal
    if (showExitIntent && !activeModal && !showSpecialOffer) {
      setActiveModal('exit');
    }
  }, [timeOnSite, hasScrolled, showExitIntent, activeModal, showSpecialOffer, modalsDisabled]);

  const closeModal = () => {
    setActiveModal(null);
    setShowSpecialOffer(false);
    setShowExitIntent(false);
    setModalsDisabled(true); // Disable all modals for this session
    // Prevent showing more modals for this session
    setTimeOnSite(-1);
  };

  return (
    <>
      <ConsultationModal
        isOpen={activeModal !== null}
        onClose={closeModal}
        type={activeModal}
      />
      <SpecialOffer
        isVisible={showSpecialOffer}
        onClose={closeModal}
      />
    </>
  );
};

export default ModalManager;